module.exports = __webpack_public_path__ + "static/media/prototype-2.8bef4c47.PNG";